import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  /**
   * Liste les société en fonction de l'id 
   * utilisateur présent dans le localstorage
   *
   * @return  {Promise}  
   */
  getCompany() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
    };

    return Network.execute('GET', 'CWEBS0001A', data);
  },
}